/* socket emit事件 */
export const socketEmitStr = {
  EVENTTYPE_0: 'event_type_0', // 查询消息总数
  EVENTTYPE_10: 'event_type_10', // 系统消息
  EVENTTYPE_20: 'event_type_20', // 客户管理
  EVENTTYPE_30: 'event_type_30', // 删除预约上门
  EVENTTYPE_220: 'store_certification', // cps部门认证
  SERVER_PUSH_EVENT_POP: 'server_push_event_pop', // 弹窗监听
  SERVERPUSHEVENTADD_0: 'server_push_event_add_0', // 增量消息-消息总数
  SERVERPUSHEVENTADD_10: 'server_push_event_add_10', // 增量消息-消息分组
  server_push_event_repeat_login: 'server_push_event_repeat_login', // 重复登录
  server_push_event_permission_change: 'server_push_event_permission_change', // 权限变更
  open_call_center_refresh_window: 'open_call_center_refresh_window', // 呼叫中心开关
  server_push_event_account_disable: 'server_push_event_account_disable', // 账号被禁用
  event_export_finish: 'event_export_finish', // 导出事件
  event_change_seat_switch: 'event_change_seat_switch', // 员工打开关闭呼叫中心
  server_push_event_add_system_notice: 'server_push_event_add_system_notice', // 系统公告订阅
  server_push_event_quick_follow_up: 'server_push_event_quick_follow_up', // 监听快速跟进
  high_seas_allocates_customers_to_employees: 'high_seas_allocates_customers_to_employees', // 公海分配客户给员工
  turn_over_customers_to_employees: 'turn_over_customers_to_employees', // 移交客户给员工
  clue_pool_distributes_customers_to_employee_clue_pool:
    'clue_pool_distributes_customers_to_employee_clue_pool', // 线索池派发客户到员工线索池
  clue_pool_distributes_customers_to_employee_customer_pool:
    'clue_pool_distributes_customers_to_employee_customer_pool', // 线索池派发客户到员工客户池
  successfully_submit_follow_up_record_evaluation:
    'successfully_submit_follow_up_record_evaluation', // 成功提交跟进记录评价
  follow_up_plan_is_in_place: 'follow_up_plan_is_in_place', // 已到跟进计划
  auto_distributes_no_limit_of_customer_limit: 'auto_distributes_no_limit_of_customer_limit', // 自动派发到客户池通知员工
  auto_distributes_limit_of_customer_limit_to_stand_by_user:
    'auto_distributes_limit_of_customer_limit_to_stand_by_user', // 自动派发到客户池通知备用员工
  the_employee_has_reached_his_limit: 'the_employee_has_reached_his_limit', // 自动派发、客户列表表格导入、移交、公海分配、回收站还原客户给某员工
  auto_distributes_limit_of_customer_limit_to_notice_user:
    'auto_distributes_limit_of_customer_limit_to_notice_user', // 自动派发达员工上限，未配备备用员工，进入主账号线索池的通知
  event_import_blacklist_complete: 'event_import_blacklist_complete', // 黑名单上传结果监听
  event_sip_bind_operate_notify: 'event_sip_bind_operate_notify', // 监听员工绑定解绑分机号
  evoke_mobile_phone_dial_event: 'evoke_mobile_phone_dial_event', // 监听唤起APP端呼叫
  evoke_mobile_phone_dial_failed_event: 'evoke_mobile_phone_dial_failed_event', // 监听唤起APP端呼叫失败
  evoke_mobile_phone_dial_success_event: 'evoke_mobile_phone_dial_success_event', // 监听唤起APP端呼叫成功
  call_center_admin_change_server_type_event: 'call_center_admin_change_server_type_event', // 监听admin切换呼叫中心线路类型serverType
  event_expire_seat_send_msg: 'event_expire_seat_send_msg', // 坐席到期提醒
  event_change_call_type_config: 'event_change_call_type_config', // 机构呼叫方式变更
  organ_phone_check_num_limit_send_msg: 'organ_phone_check_num_limit_send_msg', // 号码检验服务次数通知
  event_msg_type_520: 'event_msg_type_520', // 增值服务协议通知
  event_msg_type_500: 'event_msg_type_500', // 扫码预约上门相关通知
  event_msg_type_701: 'event_msg_type_701', // cps部门认证
  event_user_round_call_ack_and_hangup: 'event_user_round_call_ack_and_hangup', // PC唤起APP轮呼挂断通知
  call_round_task_number_import_event: 'call_round_task_number_import_event', // 轮呼任务导入号码结果
  call_round_task_create_edit_event: 'call_round_task_create_edit_event', // 轮呼任务新建推送
  evoke_mobile_phone_rc_initiate_call: 'evoke_mobile_phone_rc_initiate_call', // APP轮呼发起呼叫
  call_center_group_call_tmp_contact_import_result:
    'call_center_group_call_tmp_contact_import_result', // 群呼任务号码导入结果推送
  group_call_arrived_threshold_event: 'group_call_arrived_threshold_event', // 群呼话损告警
  evoke_mobile_phone_dial_cancel_event: 'evoke_mobile_phone_dial_cancel_event', // PC唤起APP轮呼，APP取消事件
  evoke_mobile_rc_error_event: 'evoke_mobile_rc_error_event', // PC唤起APP轮呼，APP终止轮呼
  event_eqb_identity_success_send_msg: 'event_eqb_identity_success_send_msg', // 企业认证成功
  auto_assign_seas_to_employee: 'auto_assign_seas_to_employee', // 公海自动分派
  // CRM3.2 公海
  open_sea_add_update_admin_member_event: 'open_sea_add_update_admin_member_event', // 公海新增编辑
  open_sea_add_update_recycle_rules_event: 'open_sea_add_update_recycle_rules_event', // 回收规则新增编辑
  task_phase_change_notification: 'task_phase_change_notification', // 做单中心状态变更
  async_move_to_data: 'async_move_to_data', // 离职人员移交数据进度
  shop_appoint_visit_door: 'shop_appoint_visit_door', // 预约上门 分配谈单人
  open_sea_get_customers_event: 'open_sea_get_customers_event', // 客户领取
  customer_notified_recycled: 'customer_notified_recycled', // 客户已被回收 (加)
  customer_notified_impending_recycling: 'customer_notified_impending_recycling', // 客户即将回收   (改)
  // 营销系统3.4
  event_identity_change_offline_product: 'event_identity_change_offline_product', // 产品下架
  user_auth_notice: 'user_auth_notice', // 实名认证通知
  saas_ocr_success_event: 'saas_ocr_success_event', // 人脸识别通知
  saas_real_name_update_event: 'saas_real_name_update_event', // 员工姓名或电话更新事件
  refund_notification: 'refund_notification', // 退款通知

  // 慧儿临时需求
  saas_import_success_event: 'saas_import_success_event', // 新版导入完毕事件
  // api渠道
  event_repeat_custom: 'event_repeat_custom', // 撞库
  event_user_info_repeat_auth: 'event_user_info_repeat_auth', // 机构主体变更
  // 审批流程 业务流程
  approval_notification: 'approval_notification',

  clue_convert_to_customers_event: 'clue_convert_to_customers_event', // 线索转客户
  // 优惠券发放成功的消息
  gift_coupon_notice: 'gift_coupon_notice',
  // 代客下单成功消息
  mall_place_order_notice: 'mall_place_order_notice',
  // 银行卡支付成功等待银行的回调
  pay_done_notice: 'pay_done_notice',
  // 询单需求
  inquiry_manage_add: 'inquiry_manage_add',

  sign_discard_notice: 'sign_discard_notice', // 签单作废
  add_sign_bill_notice: 'add_sign_bill_notice', // 签单新增

  // 员工与部门 上传
  user_import_notice: 'user_import_notice',
  // 新增数据之后的消息事件
  add_layout_done_notice: 'add_layout_done_notice',
  // 自动化通知
  auto_event_notify: 'auto_event_notify',

  erp_relate_org: 'erp_relate_org', // ERP-关联合作机构
  erp_un_relate_org: 'erp_un_relate_org', // 解除关联合作机构
  erp_new_order: 'erp_new_order', // 新建订单
  erp_asset_detail_new: 'erp_asset_detail_new', // 资管明细新数据
  erp_channel_fee_threshold: 'erp_channel_fee_threshold', // 通道费用阈值不足
  erp_margin_threshold: 'erp_margin_threshold', // 保证金额度不足
  erp_receivable_one_day: 'erp_receivable_one_day', // 应收款一天后到期
  erp_receivable_expire: 'erp_receivable_expire', // 应收款到期
  erp_receivable_overdue: 'erp_receivable_overdue', // 应收款逾期
  erp_balance_threshold: 'erp_balance_threshold',
  erp_balance_warning_threshold: 'erp_balance_warning_threshold',
  socket_refresh_event: 'socket_refresh_event',
  handover_customers_event: 'handover_customers_event', // 客户移交
  main_auth_notice: 'main_auth_notice', // 主体认证-审核通知
  customer_equal_private: 'customer_equal_private', // 客户数量上限
  task_card: 'task_card', // 待办事项-任务中心消息推送
  erp_early_repayment_info: 'erp_early_repayment_info', // 提前还款申请
  evoke_mobile_phone_rc_call_mark: 'evoke_mobile_phone_rc_call_mark', // 唤起app呼叫-联系情况同步PC端
  ai_alarm: 'ai_alarm', // AI面签消息通知
  return_visit_event: 'visit_back_detail', // 回访消息通知
  order_phone_check: 'order_phone_check', // 订单号码检测通知
  city_price: 'city_price', // 城市价格调整通知
  customer_data_change: 'customer_data_change', // 客户数据变更通知
  labor_clue_allocate_notice: 'labor_clue_allocate_notice' // 人工单分配通知
}
